import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '5af9c6d8-8836-4201-8224-b5d1f574545c',
  ENV: 'lognes',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
    authentication: {
      // No more auth
      enabled: false,
      appleProviderEnabled: false,
      facebookProviderEnabled: false,
      googleProviderEnabled: false,
    },
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 77,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
